export const privacy = () =>  {
	$('.privacy-policy__trigger').on('click', (e) => {
		e.preventDefault();
		$('.privacy-policy__modal').addClass('visible');
	} );
	$('.privacy-policy__close').on('click', (e) => {
		e.preventDefault();
		$('.privacy-policy__modal').removeClass('visible');
	} );
};
